// ALEX.ITEAMO.NET <<< =========================================================
import * as helpers from "/mnt/d/projects/iteamo/code/www/iteamo/public/scripts/ts/helpers/main.ts";
// /*
helpers.ready(function(){
    // let message: string = 'INSIDE!'; console.log(message);
    //
    // /*
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    let viewportWidth, viewportHeight;
    if (isIOS && window.visualViewport && window.visualViewport.height > 0) {
      viewportWidth = window.visualViewport.width;
      viewportHeight = window.visualViewport.height;
    } else {
      viewportWidth = window.innerWidth;
      viewportHeight = window.innerHeight;
    }
    console.log('isIOS', isIOS);    
    //
    if (viewportWidth < 380) {
        let func = function() {
            var objViewport = document.querySelector('meta[name="viewport"]');
            objViewport.setAttribute('content','width=380, viewport-fit=cover');    
        };
        func();    
        window.addEventListener("orientationchange", function() {
            func(); location.reload();
        });
        // alert(`Viewport dimensions: ${viewportWidth} x ${viewportHeight}`);
    }        
    // */
    // alert(`${screen.width} ${window.innerWidth} | ${screen.height} ${window.innerHeight} | ${viewportWidth}`);
    //
    // /*
    const resizeOps = () => {
        document.documentElement.style.setProperty('--vh', window.innerHeight * 0.01 + 'px');
    };    
    resizeOps();
    window.addEventListener('resize', resizeOps);    
    // */
});
// */
// DEBUG <<<
// let message: string = 'Hello, World!';
// console.log(message);
// helpers.test();
// >>> DEBUG
// =============================================================================